export const getThemeDetailsSlug = state => state.themeDetails.slug;